var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 469.333 469.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.667,192h-64h-64h-64c-5.899,0-10.667,4.779-10.667,10.667v74.667c0,5.888,4.768,10.667,10.667,10.667h64h64h64 c5.899,0,10.667-4.779,10.667-10.667v-74.667C341.333,196.779,336.565,192,330.667,192z M192,266.667h-42.667v-53.333H192V266.667 z M256,266.667h-42.667v-53.333H256V266.667z M320,266.667h-42.667v-53.333H320V266.667z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.333,
    cy: 181.333,
    r: 10.667
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.333,
    cy: 224,
    r: 10.667
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.333,
    cy: 266.667,
    r: 10.667
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.333,
    cy: 309.333,
    r: 10.667
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53.333,
    cy: 352,
    r: 10.667
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.333,128H384V96c0-17.643-14.357-32-32-32h-34.805c-9.515-36.747-42.859-64-82.528-64s-73.013,27.253-82.528,64 h-34.805c-17.643,0-32,14.357-32,32v32H32c-17.643,0-32,14.357-32,32v234.667v64c0,5.888,4.768,10.667,10.667,10.667h448 c5.899,0,10.667-4.779,10.667-10.667v-64V160C469.333,142.357,454.976,128,437.333,128z M85.333,448h-64v-42.667h64V448z  M85.333,384h-64V160c0-5.877,4.779-10.667,10.667-10.667h53.333V384z M234.667,21.333c35.296,0,64,28.704,64,64 c0,35.296-28.704,64-64,64s-64-28.704-64-64C170.667,50.037,199.371,21.333,234.667,21.333z M224,448h-64V330.667h64V448z  M309.333,448h-64V330.667h64V448z M362.667,138.667v256V448h-32V320c0-5.888-4.768-10.667-10.667-10.667H149.333 c-5.899,0-10.667,4.779-10.667,10.667v128h-32v-53.333v-256V96c0-5.877,4.779-10.667,10.667-10.667h32 c0,47.051,38.283,85.333,85.333,85.333S320,132.384,320,85.333h32c5.888,0,10.667,4.789,10.667,10.667V138.667z M448,448h-64 v-42.667h64V448z M448,384h-64V149.333h53.333c5.888,0,10.667,4.789,10.667,10.667V384z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 181.333,
    r: 10.667
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 224,
    r: 10.667
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 266.667,
    r: 10.667
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 309.333,
    r: 10.667
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 352,
    r: 10.667
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,53.333c-5.899,0-10.667,4.779-10.667,10.667v10.667H224V64c0-5.888-4.768-10.667-10.667-10.667 c-5.899,0-10.667,4.779-10.667,10.667v42.667c0,5.888,4.768,10.667,10.667,10.667c5.899,0,10.667-4.779,10.667-10.667V96h21.333 v10.667c0,5.888,4.768,10.667,10.667,10.667c5.899,0,10.667-4.779,10.667-10.667V64C266.667,58.112,261.899,53.333,256,53.333z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.686c729bfbf083797e642449f01bcfa9.svg";
export { ForwardRef as ReactComponent };